<script setup>
  import {MedLink} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PagesRecordGeneralShareStatus",
  });

  defineProps({
    patient: {
      type: Object,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
    sharedata: {
      type: Object,
      required: true,
    },
  });

  const emit = defineEmits(["open:shareStatusDialog"]);

  function openShareStatusDialog() {
    emit("open:shareStatusDialog");
  }
</script>

<template>
  <section
    v-if="sharedata.shared_by_me || sharedata.shared_with_me"
    class="print:hidden"
    :data-test="getTestId('shared-status')"
  >
    <div class="relative -bottom-4 flex cursor-default flex-row-reverse">
      <span v-if="sharedata.shared_by_me" class="flex items-center space-x-2">
        <MedLink
          as="button"
          variant="primary"
          icon="call_made"
          :data-test="getTestId('shared-status-by-me-link')"
          @click.prevent="openShareStatusDialog()"
        >
          von mir freigegeben
        </MedLink>
      </span>

      <span v-else-if="sharedata.shared_with_me" class="flex items-center">
        <MedLink
          as="button"
          variant="primary"
          icon="call_received"
          :data-test="getTestId('shared-status-with-me-link')"
          @click.prevent="openShareStatusDialog()"
        >
          für mich freigegeben
        </MedLink>
      </span>
    </div>
  </section>
</template>
